"use strict";

angular.module("customer")
.factory("RetailerUserInfoService", function($rootScope, $http, appConfig) {
    return {
        getSelectedHomeCommunityFilter: function(user) {
            return {
                filter: user.info.customer_filter,
                id: user.info.customer_filter_group
            };
        },

        getCustomerExclusiveDetails: function(user) {
            return user.exclusive_group;
        },

        getCustomerNotApprovedCorporateGroupId: function(user) {
            return user.not_approved_corporate_group_id;
        },

        getCustomerCorporateApprovalStatus: function(user) {
            return user.corporate_approval_status;
        },

        getStockPreferredSortingOrder: function() {
            if ($rootScope.user && $rootScope.user.info) {
                return $rootScope.user.info.customer_stock_preferred_sorting_order;
            }
        },

        patchCustomerUserInfo: function(data) {
            return $http({
                method: "PATCH",
                ignoreLoadingBar: true,
                url: appConfig.API_SERVER + "/auth/customer/user-info/patch/",
                data: data
            }).then(function(response) {
                $rootScope.user.info.customer_stock_preferred_sorting_order = response.data.customer_stock_preferred_sorting_order;
                $rootScope.user.info.customer_catalog_view_selected = response.data.customer_catalog_view_selected;
            });
        },
        patchCustomer: function(data) {
            $http({
                method: "PATCH",
                ignoreLoadingBar: true,
                url: appConfig.API_SERVER + "/auth/customer/patch/",
                data: data
            }).then(function(response) {
                $rootScope.user.customer.show_inventory = response.data.show_inventory;
            });
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/auth/user-info.service.js
// module id = 898
// module chunks = 0